<template>
  <div class="sign-in">
    <TopBar :title="$t('sign.mrqd')" color="white" white="true" />
    <div class="absolute-div">
      <div
        class="qiandao-sty"
        :class="{ signIned: isComplete }"
        @click="handleSignIn"
      >
        {{ signInTitle }}
      </div>
    </div>
    <div id="calendar-box">
      <van-calendar
        title=" "
        :poppable="false"
        :show-confirm="false"
        :show-mark="false"
        :show-title="false"
        :style="{
          height: '55vh',
          maxWidth: '768px',
          position: 'fixed',
          bottom: '1px',
        }"
        @confirm="selectDate"
        :min-date="maxDate"
        :max-date="maxDate"
        :formatter="formatter"
        color="#57A4E0"
      />
    </div>
  </div>
</template>

<script>
import {
  accountsTodayStatus,
  accountsToday,
  accountsCheckinDays,
} from "@/api/api.js";
import { Notify } from "vant";
import TopBar from "@/common/top-bar/index.vue";

export default {
  name: "SignIn",
  components: {
    TopBar,
  },
  data() {
    return {
      signInTitle: this.$t("sign.qd"),
      isComplete: false,
      CheckinDaysList: [],
      maxDate: new Date(new Date().valueOf()),
      calendarDate: new Date(),
      visible: false
    };
  },
  methods: {
    format(dat) {
      //获取年月日，时间
      let year = dat.getFullYear();
      let mon =
        dat.getMonth() + 1 < 10
          ? "0" + (dat.getMonth() + 1)
          : dat.getMonth() + 1;
      let data = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
      let newDate = year + "-" + mon + "-" + data;
      return newDate;
    },
    formatter(day) {
      var today = this.format(new Date());
      const date = day;
      var date1 = this.format(date.date); //将日期转为字符串
      for (var i = 0; i < this.CheckinDaysList.length; i++) {
        var date2 = this.CheckinDaysList[i].date;
        if (date1 == date2) {
          date.className = "orange-flag";
        }
      }
      if (date1 === today) {
        date.className = "orange-flag-1";
      }
      return date;
    },
    selectDate(value) {},
    handleSignIn() {
      if (this.isComplete) {
        Notify({ type: "warning", message: this.$t("sign.yjqdg") });
      } else {
        this.onConfirm();
      }
    },
    onConfirm() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      accountsToday({ id: loginInfo.id }).then((res) => {
        if (res.code === 200) {
          Notify({ type: "success", message: this.$t("signSta") });
          this.isComplete = true;
          this.signInTitle = this.$t("sign.yqd");
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    initPage() {
      //数据读取
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      accountsTodayStatus({ id: loginInfo.id }).then((res) => {
        if (res.code === 200) {
          this.isComplete = res.data.isComplete;
          if (this.isComplete) {
            this.signInTitle = this.$t("sign.yqd");
          } else {
            this.signInTitle = this.$t("sign.qd");
          }
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    CheckinDays() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      };
      accountsCheckinDays(params).then((res) => {
        if (res.code === 200) {
          this.CheckinDaysList = res.data;
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
  },
  mounted() {
    this.initPage();
    this.CheckinDays();
  },
  activated() {}
};
</script>

<style lang="stylus" scoped>
/deep/.sign-in {
  width: 100%;
  height: 100%;
  min-height: 500px;
  overflow: auto;
  background-color: #FFFFFF !important;
  background: url('../../assets/img/签到背景.png') no-repeat;
  background-size: 100% 40%;

  .absolute-div {
    display: flex;
    justify-content: center;
    margin-top: 1rem;

    .qiandao-sty {
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: bold;
      font-size: 18px;
      width: 2rem;
      height: 2rem;
      background: #4086BF;
      border-radius: 50%;
      border: 10px solid #FFFFFF;
      padding: 10px;
      cursor: pointer;
    }

    .signIned {
      background: #9CC8EB;
    }
  }
}

/deep/#calendar-box {
  margin-top: -2rem;

  .van-calendar__header {
    box-shadow: none;
  }

  .van-calendar__header-title {
    display: none !important;
  }
}

/deep/ .orange-flag {
  color: #ffffff;
  border-radius: 40px;

  &::after {
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    background-color: #F3C9B3;
    content: '';
    z-index: -1;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
}

/deep/ .orange-flag-1 {
  color: #ffffff;
  border-radius: 50%;

  .van-calendar__selected-day {
    width: 40px;
    height: 40px;
    border-radius: 40px !important;
  }
}
</style>
<style scoped>
.van-calendar >>> .van-calendar__weekdays {
  display: block;
}
.van-calendar >>> .van-calendar__weekdays > .van-calendar__weekday {
  display: inline-block;
  width: 14.285%;
}
.van-calendar
  >>> .van-calendar__body
  > .van-calendar__month
  > .van-calendar__days
  > .van-calendar__day {
  width: 14.285%;
}
/* @media only screen and (m-width: 751px) {
  .van-calendar >>> .van-calendar__weekdays > .van-calendar__weekday {
    display: inline-block;
    width: 14%;
  }
} */
.van-calendar
  >>> .van-calendar__body::-webkit-scrollbar {
  width: 1px;
  height: 10px;
  padding-right: 2px;
}

.van-calendar
  >>> .van-calendar__body::-webkit-scrollbar-thumb {

	background: #858585;

	border-radius: 10px;

}
</style>


// WEBPACK FOOTER //
// src/pages/signIn/SignIn.vue